import { CartUpdateEvent } from '@theme/events';

/*
 * ELIXIVA — añadido directo de suscripciones desde "Completa tu rutina".
 * Código aislado: Horizon renderiza el carrito. El regalo se sincroniza
 * mediante su propio listener cart:update. NO usa el runtime antiguo.
 */
if (!globalThis.__elixivaOneMoreSafeAddInitialized) {
  globalThis.__elixivaOneMoreSafeAddInitialized = true;

  let inFlight = false;
  // Mantiene bloqueada una recomendación ya añadida mientras Horizon la retira del carrusel.
  const addedVariants = new Set();

  const cartUrl = (path) => {
    const root = globalThis.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root + path : root + '/' + path;
  };

  const fetchCurrentCart = async () => {
    // Después de confirmar add.js, no repetir nunca el POST.
    // Se puede reintentar la lectura sin riesgo de duplicar artículos.
    let lastError;
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const response = await fetch(cartUrl('cart.js'), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('No se pudo leer el carrito actualizado');
        const data = await response.json();
        if (!Array.isArray(data.items) || !Number.isFinite(Number(data.item_count))) {
          throw new Error('Respuesta de carrito incompleta');
        }
        return data;
      } catch (error) {
        lastError = error;
      }
    }
    throw lastError;
  };

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-elixiva-quick-add]');
    if (!(button instanceof HTMLButtonElement) || !button.closest('.elixiva-one-more')) return;

    event.preventDefault();
    if (inFlight || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    const sellingPlanId = Number(button.dataset.sellingPlanId);
    if (addedVariants.has(variantId)) return;
    if (!Number.isSafeInteger(variantId) || variantId <= 0 ||
        !Number.isSafeInteger(sellingPlanId) || sellingPlanId <= 0) {
      console.error('[ELIXIVA recomendaciones] Variante o plan inválido');
      return;
    }

    inFlight = true;
    const initialButtons = Array.from(document.querySelectorAll('[data-elixiva-quick-add]'));
    for (const control of initialButtons) control.disabled = true;

    const feedback = button.closest('.elixiva-one-more__card')?.querySelector('.elixiva-one-more__feedback');
    if (feedback) {
      feedback.hidden = true;
      feedback.textContent = '';
    }

    let added = false;
    try {
      const response = await fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
          }],
        }),
      });
      const payload = await response.json();
      if (!response.ok || payload.status || payload.errors) {
        throw new Error(payload.description || payload.message || 'No se pudo añadir la suscripción');
      }
      added = true;
      addedVariants.add(variantId);

      const cart = await fetchCurrentCart();
      // El renderizador NATIVO de Horizon vuelve a solicitar la sección
      // sin depender de HTML que pueda venir desactualizado o null.
      document.dispatchEvent(
        new CartUpdateEvent(cart, 'elixiva-one-more-safe', {
          source: 'elixiva-one-more-safe',
          itemCount: cart.item_count,
          sections: {},
        })
      );
    } catch (error) {
      console.error('[ELIXIVA recomendaciones]', error);
      if (feedback) {
        feedback.hidden = false;
        feedback.textContent = added
          ? 'La suscripción se ha añadido, pero el carrito no se ha actualizado. Recarga la página.'
          : 'No se ha podido añadir. Inténtalo de nuevo.';
      }
    } finally {
      inFlight = false;
      // El render de Horizon puede sustituir el botón que recibió el clic.
      for (const control of document.querySelectorAll('[data-elixiva-quick-add]')) {
        control.disabled = addedVariants.has(Number(control.dataset.variantId));
      }
    }
  });

  // Cuando se quita un producto, su recomendación se puede volver a añadir.
  document.addEventListener('cart:update', (event) => {
    const items = event.detail?.resource?.items;
    if (!Array.isArray(items)) return;
    for (const id of addedVariants) {
      if (!items.some((item) => Number(item.variant_id) === id)) {
        addedVariants.delete(id);
      }
    }
    for (const control of document.querySelectorAll('[data-elixiva-quick-add]')) {
      if (!inFlight) control.disabled = addedVariants.has(Number(control.dataset.variantId));
    }
  });
}
